<template>
  <div class="flex h-[calc(100vh-60px)] relative" style="background: #F9FBFD;">
    <!-- Left Sidebar -->
    <div :class="['left', { collapsed: isSidebarCollapsed }]" class="transition-all duration-500 ease-in-out relative">
      <div v-show="!isSidebarCollapsed" class="sidebar-content">
        <Tab
          v-model="activeSection"
          type="vertical"
          :tabs="sidebarTabs"
          @change="handleSectionChange"
        />
      </div>
    </div>

    <!-- Collapse/Expand Button -->
    <button 
      class="collapse-expand-button" 
      :style="{ left: isSidebarCollapsed ? '26px' : '320px' }"
      @click="toggleSidebar"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :style="{ transform: isSidebarCollapsed ? 'rotate(180deg)' : 'none' }">
        <path d="M17.59 6L19 7.41L14.42 12L19 16.59L17.59 18L11.59 12L17.59 6Z" fill="#374957"/>
        <path d="M11 6L12.41 7.41L7.83 12L12.41 16.59L11 18L5 12L11 6Z" fill="#374957"/>
      </svg>
    </button>

    <!-- Main Content Area -->
    <div :class="['right', { shifted: isSidebarCollapsed }]">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import EzBillIcon from '@/assets/MyWorkBench/sidebar/ez-bill.svg';
import DocumentTemplateIcon from '@/assets/MyWorkBench/sidebar/document-template.svg';
import AutomationIcon from '@/assets/MyWorkBench/sidebar/automation.svg';
import TemplateMarketplaceIcon from '@/assets/MyWorkBench/sidebar/template-marketplace.svg';
import ArchiveIcon from '@/assets/MyWorkBench/sidebar/archive.svg';

export default {
  name: 'WorkbenchLayout',

  data() {
    return {
      sidebarTabs: [
        { value: 'ez-bill', label: 'eZ-Bill', icon: EzBillIcon },
        { value: 'document-template', label: 'Document Template', icon: DocumentTemplateIcon },
        { value: 'workflow', label: 'Automation', icon: AutomationIcon },
        { value: 'template-marketplace', label: 'Template Marketplace', icon: TemplateMarketplaceIcon },
        { value: 'archive', label: 'Archive', icon: ArchiveIcon },
      ],
    };
  },

  computed: {
    ...mapState('workbench', ['currentSection', 'isSidebarCollapsed']),

    activeSection: {
      get() {
        return this.currentSection;
      },
      set(section) {
        this.setCurrentSection(section);
      },
    },
  },

  mounted() {
    // Set initial section based on current route
    const path = this.$route.path;
    if (path.includes('/automation')) {
      this.setCurrentSection('workflow');
    } else if (path.includes('/ez-bill')) {
      this.setCurrentSection('ez-bill');
    } else if (path.includes('/document-template')) {
      this.setCurrentSection('document-template');
    } else if (path.includes('/report-format')) {
      this.setCurrentSection('report-format');
    } else if (path.includes('/archive')) {
      this.setCurrentSection('archive');
    }
  },

  methods: {
    ...mapActions('workbench', ['setCurrentSection', 'toggleSidebar']),

    handleSectionChange(section) {
      // Map 'workflow' section to 'automation' route
      const routePath = section === 'workflow' ? 'automation' : section;
      this.$router.push(`/my-workbench/${routePath}`);
    },
  },
};
</script>

<style scoped>
/* Left Sidebar Styles - Same as My Patients */
.left {
  background: #F9FBFD;
  display: flex;
  flex-direction: column;
  padding: 0;
  border-radius: 0 10px 10px 0;
  box-shadow: 0px 2px 15px 0px #4A4A4A40;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 334px;
  transition: all 0.5s ease-in-out;
  height: calc(100vh - var(--nav-height));
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-color: transparent transparent;
  z-index: 50;
}

.left.collapsed {
  width: 40px;
}

.left:hover {
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.sidebar-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 334px;
  height: 100%;
  overflow: hidden;
}

/* Collapse Button Styles - Positioned relative to parent container */
.collapse-expand-button {
  position: absolute;
  top: 50%;
  left: 320px;
  transform: translateY(-50%);
  display: flex;
  padding: 24px 2px;
  align-items: center;
  gap: 12px;
  border-radius: 4px;
  background: #F2F2F2;
  border: none;
  cursor: pointer;
  z-index: 100;
  transition: all 0.5s ease-in-out;
}

.collapse-expand-button:hover {
  background: #E5E7EB;
}

.collapse-expand-button svg {
  transition: transform 0.5s ease-in-out;
}

/* Main Content Styles - Same as My Patients */
.right {
  margin-left: 334px;
  transition: all 0.5s ease-in-out;
  display: flex;
  flex-grow: 1;
  min-width: 0;
  height: calc(100vh - var(--nav-height));
  overflow-y: hidden;
  z-index: 10;
  position: relative;
}

.right.shifted {
  margin-left: 24px;
}
</style>
